<script context="module" lang="ts">
  let counter = 0;
</script>

<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import type { InputEvent } from '@shared/types';
  import { is } from '@shared/utils';

  export let label: string | undefined = undefined;
  export let name: string | undefined = undefined;
  export let disabled: boolean = false;
  export let isChecked = false;

  const dispatch = createEventDispatcher<{ change: InputEvent }>();
  const switchId = `switch-${++counter}`;

  const onChange = (e: InputEvent) => {
    if (disabled) return;

    isChecked = e.currentTarget.checked;
    dispatch('change', e);
  };
</script>

<label for="{switchId}" class="flex cursor-pointer items-center gap-2">
  <span
    class="relative block h-5 w-9 rounded-full transition-colors {is(
      isChecked,
      'bg-default-900 dark:bg-dark-900',
      'bg-default-200 dark:bg-dark-500', // set brighter color to be visible in modals, left the commented line for future reference in case we have some design troubles in other forms
    )}"
  >
    <span
      class="absolute bottom-0 left-0.5 top-0 my-auto h-4 w-4 rounded-full shadow-lg transition-transform {is(
        isChecked,
        'dark:bg-dark-50 translate-x-full bg-white',
        'bg-default-50 dark:bg-dark-50',
      )}"
    ></span>
  </span>
  {#if label}
    {label}
  {/if}
</label>

<input
  bind:checked="{isChecked}"
  {name}
  {disabled}
  type="checkbox"
  class="hidden"
  id="{switchId}"
  on:change="{onChange}"
/>
